import { render, staticRenderFns } from "./edition.vue?vue&type=template&id=7be97937&scoped=true"
import script from "./edition.vue?vue&type=script&lang=js"
export * from "./edition.vue?vue&type=script&lang=js"
import style0 from "./edition.vue?vue&type=style&index=0&id=7be97937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be97937",
  null
  
)

export default component.exports